"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @hidden
 */
exports.MIDNIGHT_DATE = new Date(1980, 0, 1);
/**
 * @hidden
 */
exports.MIN_DATE = new Date(1900, 0, 1);
/**
 * @hidden
 */
exports.MAX_DATE = new Date(2099, 11, 31);
/**
 * @hidden
 */
exports.MIN_TIME = new Date(1980, 0, 1);
/**
 * @hidden
 */
exports.MAX_TIME = new Date(1980, 0, 1, 23, 59, 59);
//# sourceMappingURL=defaults.js.map


//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/@progress+kendo-react-dateinputs@3.18.0_@progress+kendo-react-intl@3.18.0_react-dom@16.14.0_r_2yelhkp6sdgaltctm3m4k3bqy4/~/@progress/kendo-react-dateinputs/dist/npm/defaults.js
// module id = 58
// module chunks = 0